import { ref, watchEffect } from "vue";
const createAutofocusProp = () => ({
  autofocus: {
    type: Boolean,
    default: false
  }
});
const useAutofocus = (props, inputRef = ref(null)) => {
  watchEffect(() => {
    if (props.autofocus && inputRef.value) inputRef.value.focus();
  });
  return { inputRef };
};
export {
  createAutofocusProp as c,
  useAutofocus as u
};
